import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'

export default class TimeTrackDescriptionStrategy extends DescriptionStrategy {
    constructor({ reportUrl = '' }) {
        super()
        this.params = { reportUrl }
    }

    getHeader() {
        return messageResource.getMessage('report.newTimetrack.header')
    }

    getDescription() {
        const firstParagraph = messageResource.getEscapedMessage('dashboard.description.timetrack.part1')
        const secondParagraph = messageResource.getEscapedMessage('dashboard.description.timetrack.part2')
        return '<div>' +
               '  <div class="firstParagraph workStatusesDescriptionColor">' + firstParagraph + '</div>' +
               '  <div class="secondParagraph">' + secondParagraph + '</div>' +
               '</div>'
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }

    getDetailsCallback() {
        openUserGuidePage('reporting#report-time-track')
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/TimeTrackDescriptionStrategy.js